import Button from '@ui-library/button';
import { FixMe } from '@utils/types';
import { InputProps } from 'antd/lib/input';
import React from 'react';
import { EditColumnWrapper, EditableInput, ButtonWrapper, ErrorPopover } from './style';

interface DynamicInputComponentProps extends InputProps {
  onAdd: (v: FixMe) => void;
  error?: string | null;
  onErrorVisibleChange?: () => void;
  inputComponent?: FixMe;
}

const DynamicInputComponent = ({
  onChange,
  onAdd,
  error,
  onKeyPress,
  value: defValue,
  onErrorVisibleChange,
  inputComponent: InputComponent = EditableInput,
}: DynamicInputComponentProps) => {
  const [value, setValue] = React.useState(defValue);
  const onChangeCL = React.useCallback((e: FixMe) => {
    const val = typeof e?.target?.value === 'undefined' ? e : e?.target?.value;
    if (onChange) {
      onChange(val);
    }
    setValue(val);
  }, []);
  return (
    <EditColumnWrapper editMode>
      <InputComponent
        style={{ margin: '4px', padding: '5px 10px', width: '100%' }}
        onKeyDown={onKeyPress}
        value={value}
        onChange={onChangeCL}
      />
      <ButtonWrapper>
        <ErrorPopover
          overlayClassName="errorOverlay"
          content={<div style={{ color: '#EB0000' }}>{error}</div>}
          trigger="click"
          visible={!!error}
          onVisibleChange={(visible) => !visible && onErrorVisibleChange && onErrorVisibleChange()}
        >
          <Button
            onClick={(e: FixMe) => {
              e.stopPropagation();
              e.preventDefault();
              if (onAdd) {
                onAdd(value);
              }
            }}
            style={{
              backgroundColor: '#00bfff ',
              color: 'white',
              margin: '4px',
              fontSize: 15,
              height: 'unset',
              border: '1px solid #DEDEDE',
              borderRadius: '6px',
            }}
            name="Ok"
          />
        </ErrorPopover>
      </ButtonWrapper>
    </EditColumnWrapper>
  );
};

export default DynamicInputComponent;
